/**
 * Vue Router 配置
 * 定义应用的所有路由和导航规则
 */
import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

/**
 * 应用路由表
 * 包含认证页面和主应用功能页面
 */
const routes: RouteRecordRaw[] = [
  // Auth routes (no layout)
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: { title: '注册' }
  },
  // Main routes (layout handled by App.vue)
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/HomeView.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/eq',
    name: 'EQ',
    component: () => import('@/views/eq/EqView.vue'),
    meta: { title: 'EQ设置' }
  },
  {
    path: '/rgb',
    name: 'RGB',
    component: () => import('@/views/rgb/RgbControl.vue'),
    meta: { title: 'RGB灯光' }
  },
  {
    path: '/noise',
    name: 'NoiseReduction',
    component: () => import('@/views/noise/NoiseReduction.vue'),
    meta: { title: '降噪设置' }
  },
  {
    path: '/voice',
    name: 'VoiceEffect',
    component: () => import('@/views/voice/VoiceEffect.vue'),
    meta: { title: '变声音效' }
  },
  {
    path: '/chiji',
    name: 'Chiji',
    component: () => import('@/views/chiji/ChijiView.vue'),
    meta: { title: '一键吃鸡' }
  },
  {
    path: '/upgrade',
    name: 'FirmwareUpgrade',
    component: () => import('@/views/upgrade/FirmwareUpgrade.vue'),
    meta: { title: '固件升级' }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user/UserProfile.vue'),
    meta: { title: '用户中心', requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Update page title
  document.title = to.meta.title ? `${to.meta.title} | Aiiifly` : 'Aiiifly | 飞籁云驱'

  // Check authentication if required
  // DEV_BYPASS: set localStorage.devBypassAuth = '1' in browser console to skip auth guard
  const devBypass = import.meta.env.DEV && localStorage.getItem('devBypassAuth') === '1'
  if (to.meta.requiresAuth && !devBypass) {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
    if (!isLoggedIn) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
      return
    }
  }

  next()
})

export default router
